import React from 'react';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { MARKET_AVAILABLE, MARKET_URL } from '../../data/market/config';

/** Aviso temporal mientras el Market no esté disponible. Desaparece al poner MARKET_AVAILABLE = true. */
export function MarketNotice() {
  if (MARKET_AVAILABLE) return null;
  return <div role="status" className="flex items-start gap-3 rounded-2xl border border-amber-400/40 bg-amber-400/10 px-4 py-3 text-sm text-amber-100" data-id="element-1023" data-mp="js11h7cp46j9">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" aria-hidden="true" data-id="element-1024" data-mp="osezdwkl203k" />
      <p data-id="element-1025" data-mp="tr03w86vb5xt">
        <strong className="font-semibold text-amber-200" data-id="element-1026" data-mp="xqr1auqwgkbb">Aviso temporal:</strong> el Vanguard Market todavía no está disponible para usarse. Esta guía te prepara para cuando abra; avisaremos en cuanto puedas operar.
      </p>
    </div>;
}

/** Botón para abrir el Market en otra pestaña. Mientras no esté disponible se muestra desactivado. */
export function OpenMarketButton({
  compact = false
}: {
  compact?: boolean;
}) {
  const base = `inline-flex ${compact ? 'h-10 px-4 text-sm' : 'h-12 px-6 text-sm md:text-base'} items-center justify-center gap-2 rounded-full font-cinzel font-bold whitespace-nowrap`;
  if (!MARKET_AVAILABLE) {
    return <span aria-disabled="true" className={`${base} cursor-not-allowed border border-white/15 text-gray-400`} data-id="element-1027" data-mp="1xur8ggfjediw">
        Market no disponible por ahora
      </span>;
  }
  return <a href={MARKET_URL} target="_blank" rel="noopener noreferrer" className={`${base} bg-[#D4AF37] text-[#050b14] transition-colors duration-150 hover:bg-[#E3C158]`} data-id="element-1028" data-mp="2plf9lsh7niwk">
      Abrir Vanguard Market
      <ExternalLink className="h-4 w-4" aria-hidden="true" data-id="element-1029" data-mp="2gjo2qkaxp614" />
      <span className="sr-only" data-id="element-1030" data-mp="2gmabuodh3tlg">(se abre en otra pestaña)</span>
    </a>;
}